import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

// Per-tenant overrides for the four order note types (PD-15892).
//
// The types themselves, their default labels and their default order ship in
// code (ORDER_NOTE_TYPES in constants/order-note-types.ts), so every tenant has
// them with nothing to seed. A row exists only when a tenant changes a default
// from Settings > Order Notes: hiding a type, renaming it, or moving it. A row
// that is changed back to match the default is soft-removed, so "no row" always
// means "the code default applies". Resolution is resolveOrderNoteTypes().
//
// The overrides are a CRM presentation choice only. `order_note.type` keeps its
// stored values, the API still accepts every type, and PDFs and the driver
// screens keep the code labels (owner decision on PD-15892).
//
// Uniqueness of `noteType` among active rows is kept by the service, which
// reuses the existing row (recovering a soft-removed one) rather than inserting
// a second.
@Index('idx_order_note_type_config_note_type', ['noteType'], {})
@Entity('order_note_type_config')
export class OrderNoteTypeConfigEntity extends BaseEntity {
	// One of the OrderNoteType values ('1' to '4'), the same strings
	// order_note.type holds.
	@Column('varchar', { name: 'noteType', length: 10 })
	public noteType!: string;

	// Whether the CRM offers this type for new notes. Existing notes of a hidden
	// type stay visible, read-only.
	@Column('tinyint', { name: 'isVisible', width: 1, default: () => "'1'" })
	public isVisible!: boolean;

	// The tenant's own name for the type in the CRM. Null keeps the code label.
	@Column('varchar', { name: 'labelOverride', length: 100, nullable: true })
	public labelOverride!: string | null;

	// Zero-based position among the types. Null keeps the code position.
	@Column('int', { name: 'sortOrder', nullable: true })
	public sortOrder!: number | null;
}
